module.exports = __webpack_public_path__ + "img/IMG_2073.2b352d46.jpg";